var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftCardContainer" },
    [
      _c("loading-spinner", {
        attrs: {
          active: _vm.submitLoading,
          "is-full-page": true,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.submitLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "rightSideTitleActions" }, [
        _c("span", { staticClass: "leftTitle" }, [
          _vm._v(_vm._s(_vm.$t("Validate")))
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.conflicts.length > 0,
                expression: "conflicts.length > 0"
              }
            ],
            staticClass: "actionsContainer",
            style: { visibility: _vm.activeTab !== 0 ? "hidden" : "visible" }
          },
          [
            _c(
              "div",
              { staticClass: "searchContainer" },
              [
                _c("v-icon", [_vm._v(" search ")]),
                _vm._v(" "),
                _c("InputField", {
                  attrs: {
                    inputType: "text",
                    value: _vm.search,
                    placeholder: _vm.$t("Search"),
                    inputStyle: {
                      borderRadius: "0px",
                      width: "130px",
                      borderTop: "none",
                      borderRight: "none",
                      borderLeft: "none",
                      borderBottom: "1px solid rgba(118, 118, 118, 0.50)"
                    }
                  },
                  on: {
                    input: function($event) {
                      return _vm.handleSearch($event)
                    }
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasImportSelected,
              expression: "hasImportSelected"
            }
          ],
          staticClass: "tabsContainer"
        },
        [
          _c("Tabs", {
            ref: "conflictsTable",
            attrs: {
              activeTab: _vm.activeTab,
              tabs: _vm.tabs,
              centerTabs: false,
              "tabs-styling": _vm.tabsStyling,
              "tabs-labels-styling": _vm.tabsLabelsStyling
            },
            on: { startTabChange: _vm.setActiveTab }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          style: { height: _vm.hasImportSelected ? "calc(92% - 86px)" : "100%" }
        },
        [
          !_vm.hasImportSelected
            ? _c("div", { staticClass: "empty-table" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("ImportsMessage")))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("Table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.conflicts.length > 0 && !_vm.isLastTab,
                expression: "conflicts.length > 0 && !isLastTab"
              }
            ],
            attrs: {
              "scroll-id": _vm.tableId,
              checkbox: false,
              loading: _vm.tableLoading,
              headers: _vm.headers,
              items: _vm.conflicts,
              sortable: true,
              emitRowClickBusEvent: false,
              conflicts: true
            },
            on: {
              "selected-conflicts": _vm.handleSelectedConflicts,
              onScrollBottom: _vm.onScrollBottom,
              onScrollTop: _vm.onScrollTop,
              sortClick: _vm.onSortClick
            }
          }),
          _vm._v(" "),
          _c("imports-summary", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasImportSelected && _vm.isLastTab,
                expression: "hasImportSelected && isLastTab"
              }
            ],
            attrs: { fields: _vm.summaryFields }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasImportSelected
        ? _c(
            "div",
            { staticClass: "action-buttons" },
            [
              _c("custom-button", {
                attrs: {
                  label: _vm.$t("Cancel"),
                  type: "cancel",
                  "button-color": "#fff",
                  "label-color": "var(--app-primary-base)",
                  "button-styling": _vm.actionButtonsStylingSave
                },
                on: { buttonClick: _vm.clearTable }
              }),
              _vm._v(" "),
              _c("custom-button", {
                attrs: {
                  "is-loading": _vm.submitLoading,
                  label: _vm.submitButtonLabel,
                  "button-color": "var(--app-primary-base)",
                  "label-color": "#FFF",
                  disabled: !_vm.showValidate
                },
                on: { buttonClick: _vm.submitHandler }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("LoadingSpinner", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-468056b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-468056b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Data/Imports/TableViewConflicts.vue
// module id = null
// module chunks = 